import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

// Аналитика iRitual: льётся в общий project iRitual (id 384508).
// cross_subdomain_cookie позволяет видеть юзера как одного человека
// между iritual.kz и поддоменами (включая blagoustroistvo.iritual.kz).
posthog.init("phc_sMU29PLzuPbZitZ78mzVYf4LWLzECAfYyUhr9Y7M7ifK", {
  api_host: "https://us.i.posthog.com",
  defaults: "2025-05-24",
  person_profiles: "identified_only",
  cross_subdomain_cookie: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);
